export enum StorageType {
  sessionStorage = 'sessionStorage',
  localStorage = 'localStorage',
}
